import { render, staticRenderFns } from "./Rutas.vue?vue&type=template&id=3e66b35c&"
import script from "./Rutas.vue?vue&type=script&lang=js&"
export * from "./Rutas.vue?vue&type=script&lang=js&"
import style0 from "./Rutas.vue?vue&type=style&index=0&id=3e66b35c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports